import { TEXT_PROPS } from './default-props';

// Mood Board Color
export const BG_PRIMARY = '#fff7ed';
export const BG_SECONDARY = 'rgba(187,87,109,0.7)';
export const BG_ALTERNATIVE = 'rgba(243,229,228,.61)';
export const BG_LAYER = 'rgba(255, 247, 237, 0.81)';
// Text Color
export const TEXT_PRIMARY = '#636345';
export const TEXT_SECONDARY = '#cfaa64';
export const TEXT_ALTERNATIVE = '#8e8f51';
export const TEXT_BUTTON = '#FFF';

export const ASSET_COLOR = '#766963';

// Music & Navigation Color
export const NAVIGATION_COLOR = 'rgba(129, 129, 99, 0.9)';
export const ICON_NAVIGATION_COLOR = 'white';

// Default Button Color
export const BUTTON_PROPS = {
  _hover: { opacity: '.8' },
};

export const BUTTON_PADDING_PROPS = {
  ...TEXT_PROPS.body,
  variant: 'solid',
  padding: '18px 22px',
  borderRadius: '18px',
  background: 'linear-gradient(to right, #8e8f51, #98957e)',
  color: '#FFF',
  size: 'sm',
  boxShadow: 'sm',
  fontSize: 'calc(var(--chakra-fontSizes-body) - 2px)',
  position: 'relative',
  fontStyle: 'normal',
  zIndex: '20',
  minWidth: '120px',
  _hover: {
    opacity: '.7',
  },
};

export const DEFAULT_BUTTON_PROPS = {
  fontWeight: 'normal',
};
